<div class="row">
  <ng-container
    *ngIf="
      accountState !== AccountState.Pending &&
      accountState !== AccountState.Failed
    "
  >
    <div
      class="col-auto account-locked"
      [ngClass]="{ disabled: !canPlaceOrders }"
      [ngbTooltip]="
        !canPlaceOrders
          ? 'Account Locking feature is only enabled for Owner and Order Managers'
          : ''
      "
    >
      <div class="account-locked__status">
        <div class="account-locked__status--title">
          Account status:
          <span [ngbTooltip]="accountStateTooltips[accountState]">
            <ng-container
              *ngIf="accountState === AccountState.Success; else default"
            >
              Active </ng-container
            ><ng-template #default>{{ accountState }}</ng-template>
          </span>
        </div>
        <div
          *ngIf="accountState === AccountState.DeleteScheduled && !isLoading"
          class="account-locked__status--title"
          style="display: none"
        >
          Deletion scheduled at:
          <span>{{ accountDetails?.deleteAt | date: 'yyyy-MM-dd H:mm' }}</span>
        </div>
      </div>

      <ng-container *ngFor="let button of actionButtons[accountState]">
        <ng-container
          *ngIf="button.enabled"
          [ngTemplateOutlet]="actionButton"
          [ngTemplateOutletContext]="{
            name: button.name,
            class: button.class,
            action: button.action,
            disabled: false
          }"
        >
        </ng-container>

        <ng-template
          #actionButton
          let-name="name"
          let-class="class"
          let-disabled="disabled"
          let-action="action"
        >
          <button
            [disabled]="disabled"
            [ngClass]="class"
            (click)="openDialog(action)"
          >
            {{ button.name }}
          </button>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
  <div
    *ngIf="canInvitePartner"
    class="col-auto"
    [ngClass]="{ disabled: hasInviteButtonsDisabled }"
  >
    <button class="btn btn-primary" (click)="openInvitePartnerUserModal.emit()">
      <i class="fas fa-handshake"></i>
      Invite Partner
    </button>
  </div>
  <div
    *ngIf="canInviteStaff"
    class="col-auto"
    [ngClass]="{ disabled: hasInviteButtonsDisabled }"
  >
    <button class="btn btn-primary" (click)="openInviteStaffUserModal.emit()">
      <i class="fas fa-user-cog"></i>
      Invite Staff User
    </button>
  </div>
  <div
    *ngIf="isStaffUserOnAccount && canAddStaff; else addAsStaffButton"
    ngbTooltip="Sign in to APSIS One as Staff User on this account"
    id="go-to-as-staff-user-button"
    class="col-auto"
    [ngClass]="{ disabled: hasInviteButtonsDisabled }"
  >
    <button class="btn btn-primary" (click)="goToOneAsStaffUser()">
      <i class="fas fa-sign-in-alt"></i> Go to account as Staff User
    </button>
  </div>
  <ng-template #addAsStaffButton>
    <div
      *ngIf="!isAlreadyOnAccount && !isLoading"
      class="col-auto"
      [ngClass]="{ disabled: hasInviteButtonsDisabled }"
    >
      <div
        ngbDropdown
        placement="bottom-right"
        [ngbTooltip]="addAsStaffTooltipMessage"
        class="btn-group dropdown-menu-right"
      >
        <button
          type="button"
          class="btn btn-primary"
          (click)="confirmAddStaffAdmin.emit()"
          id="staffUserDropdown"
        >
          <i class="fas fa-ambulance"></i> Add me as Staff User
        </button>
        <button
          type="button"
          class="btn btn-primary dropdown-toggle dropdown-toggle-split"
          id="dropdownToggleSplit"
          ngbDropdownToggle
        >
          <span class="sr-only"></span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownToggleSplit">
          <button
            ngbDropdownItem
            class="dropdown-item"
            (click)="confirmAddStaffAdmin.emit(UserRoles.Admin)"
          >
            With <b>Admin</b> permissions
          </button>
          <ng-container *ngFor="let user of users">
            <button
              ngbDropdownItem
              class="dropdown-item"
              (click)="confirmAddStaffAdmin.emit(user.id)"
            >
              With permissions of <b>{{ user.name }}</b>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
  <div
    [ngbTooltip]="inviteUserTooltipMessage"
    class="col-auto"
    [ngClass]="{ disabled: hasInviteButtonsDisabled }"
  >
    <button
      [disabled]="isLoading || !canInviteUsers || accountHasFailedState"
      class="btn btn-success"
      (click)="openInviteUserModal.emit()"
      id="invite-user-button"
    >
      <i class="fas fa-plus"></i> Invite user
    </button>
  </div>
</div>
